import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getSourceLabel } from '../../lib/utils';
import { SOURCES } from '../../constants/sources';

import ActionButtons from '../../components/error-message/action-buttons';
import ErrorMessage from '../../components/error-message';
import FluidContainer from '../../components/layouts/components/fluid-container';
import Stack from '../../components/stack';
import { Body } from '../../components/typography';

export const AttempsErrorMessage = () => (
    <ErrorMessage title="Hai esaurito i tentativi disponibili">
        <Stack gap="desktop">
            <Stack gap="base">
                <Body>
                    {`L'insegnante ha stabilito un numero di tentativi limitato per svolgere questa prova: li hai già usati tutti.`}
                </Body>
                <Body>{'Hai bisogno di aiuto? Contattaci.'}</Body>
            </Stack>
            <ActionButtons />
        </Stack>
    </ErrorMessage>
);

export const GenericErrorMessage = ({ source, isLtiLaunch }) => (
    <ErrorMessage title="Oh no, qualcosa è andato storto!">
        <Stack gap="desktop">
            <>
                {source === SOURCES.GOOGLE_CLASSROOM ? (
                    <Body>
                        {`Non siamo riusciti a caricare gli esercizi.`} <br />
                        {`Torna su ${getSourceLabel(source)} e seleziona di nuovo la prova da svolgere.`}
                    </Body>
                ) : (
                    !isLtiLaunch && <Body>{`Torna su ${getSourceLabel(source)} e cerca di nuovo la prova. `}</Body>
                )}

                <Body>{'Hai bisogno di aiuto? Contattaci.'}</Body>
            </>
            <ActionButtons />
        </Stack>
    </ErrorMessage>
);

export const ErrorPage = ({ source, errorType, googleCourseWorkId, isLtiLaunch }) => {
    const backSource = !!googleCourseWorkId ? SOURCES.GOOGLE_CLASSROOM : source;

    return (
        <FluidContainer flexDirection="column" maxWidth={['100%', '50%', '50%']} paddingTop={144} px={['base', 0]}>
            {errorType === 'TOO_MANY_ATTEMPTS' ? (
                <AttempsErrorMessage />
            ) : (
                <GenericErrorMessage source={backSource} isLtiLaunch={isLtiLaunch} />
            )}
        </FluidContainer>
    );
};

GenericErrorMessage.propTypes = {
    source: PropTypes.string,
    isLtiLaunch: PropTypes.bool,
};

ErrorPage.propTypes = {
    source: PropTypes.string,
    googleCourseWorkId: PropTypes.string,
    errorType: PropTypes.oneOf(['TOO_MANY_ATTEMPTS', 'GENERIC']),
    isLtiLaunch: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        source: state.application.source,
        googleCourseWorkId: state.application.googleCourseWorkId,
        isLtiLaunch: state.application.isLtiLaunch,
    };
};

export default connect(mapStateToProps)(ErrorPage);
